/** Last successful refresh time (epoch ms) — same cookie jar as other dashboard cookies. */

export const DASHBOARD_ACCESS_TOKEN_REFRESHED_AT_COOKIE = 'dashboard_access_token_refreshed_at';

export const NOTIFICATIONS_ACCESS_TOKEN_REFRESH_COOLDOWN_MS = 10 * 60 * 1000;

/** Dev http:// often cannot store Secure cookies; mirror what works for `dashboard_login_user_creds`. */
function cookieAttributeSuffix() {
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return 'path=/; Secure; SameSite=None';
  }
  return 'path=/; SameSite=Lax';
}

function getCookieValue(name) {
  if (typeof document === 'undefined') return null;
  function escapeRe(s) {
    return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
  }
  const match = document.cookie.match(RegExp('(?:^|;\\s*)' + escapeRe(name) + '=([^;]*)'));
  return match ? match[1] : null;
}

/** Epoch ms from cookie, or null if missing / invalid. */
export function getLastAccessTokenRefreshTimestampMs() {
  const raw = getCookieValue(DASHBOARD_ACCESS_TOKEN_REFRESHED_AT_COOKIE);
  if (raw == null || raw === '') return null;
  const n = Number(String(raw).trim());
  return Number.isFinite(n) ? n : null;
}

/** Persist last successful refresh time (plain number string in cookie). */
export function setLastAccessTokenRefreshTimestampCookie() {
  if (typeof document === 'undefined') return;
  try {
    const payload = String(Date.now());
    const d = new Date();
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
    const attrs = cookieAttributeSuffix();
    document.cookie = `${DASHBOARD_ACCESS_TOKEN_REFRESHED_AT_COOKIE}=${payload}; expires=${d.toUTCString()}; ${attrs}`;
  } catch {
    // ignore
  }
}

export function clearNotificationsAccessTokenLastOkCookie() {
  if (typeof document === 'undefined') return;
  document.cookie = `${DASHBOARD_ACCESS_TOKEN_REFRESHED_AT_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}

// React Strict Mode can run the effect twice before the cookie is written — brief in-memory dedupe.
const IMMEDIATE_DEDUPE_MS = 4000;
let immediateDedupeAt = 0;

export function shouldSkipImmediateRefreshToken() {
  const lastOk = getLastAccessTokenRefreshTimestampMs();
  if (
    lastOk != null &&
    Date.now() - lastOk < NOTIFICATIONS_ACCESS_TOKEN_REFRESH_COOLDOWN_MS
  ) {
    return true;
  }
  if (
    immediateDedupeAt > 0 &&
    Date.now() - immediateDedupeAt < IMMEDIATE_DEDUPE_MS
  ) {
    return true;
  }
  return false;
}

export function markImmediateRefreshTokenAttempt() {
  immediateDedupeAt = Date.now();
}
